class HemmingServiceAccordion extends HTMLElement {
  constructor() {
    super();
    this.addToCartButton = document.querySelector('.product-form__submit'); 
    this.buyButtonGroup = document.querySelector('.main-product .buy-button__group');
    
    this.selectSize = this.querySelector('.hemming_content-Size');
    this.selectType = this.querySelector('.hemming_content-Type');
    this.toggleService = this.querySelector('summary');
    
    this.inputType = document.querySelector('.main-product .service-type');
    this.inputPrice = document.querySelector('.main-product .service-price');
    this.inputSize = document.querySelector('.main-product .service-size');

    this.init();
  }
  
  init() {
    // fix 1 - Initialize currentValue only if it doesn't exist yet, instead of clearing it on init.
    // this.clearFormData();
    this.currentValue ||= { type:'', size:'', price:'' };
    // end fix 1
    
    this.setServiceTypeFormData();
    this.updateButtonState();
    
    if (this.selectType) {
      this.selectType.addEventListener('change', () => {
        const selectedType = this.selectType.selectedOptions[0];
        // fix 2 - replace fetching from visible text with data-name attribute from Hemming Type options
        // this.currentValue.type = selectedType.textContent;
        this.currentValue.type = selectedType.dataset.name; 
        // end fix 2
        this.currentValue.price = selectedType.value !== '' ? `¥${selectedType.value}` : '';
        this.setServiceTypeFormData();
        this.updateButtonState();
      });
    }
    
    if (this.selectSize) {
      this.selectSize.addEventListener('change', () => {
        this.setServiceSizeFormData();
        this.updateButtonState();
      });
    }
  }
  
  setServiceTypeFormData() {
    const currentValue = this.selectSize ? this.selectSize.value : '';
    if (this.selectSize) {
      this.selectSize.options.length = 1;
    }
    if (this.selectType && this.selectType.value) {
      const optionSelected = this.selectType.selectedOptions[0];
      const listSize = optionSelected.dataset.typeSize.split(',');
      listSize.forEach((size) => {
        const option = document.createElement('option');
        option.value = size;
        option.dataset.type = optionSelected.dataset.name;
        option.textContent = size;
        this.selectSize.appendChild(option);
      });

      // fix 3 - make type and price always match the selected option, instead of relying on past state.
      this.currentValue.type = optionSelected.dataset.name;
      this.currentValue.price = optionSelected.value ? `¥${optionSelected.value}` : '';
      // end fix 3
    }    
    
    if (this.selectSize) {
      const isValidValue = Array.from(this.selectSize.options).some((option) => option.value === currentValue);
      if (isValidValue && currentValue) {
        this.currentValue.size = currentValue;
        this.selectSize.value = currentValue;
      } else {
        this.selectSize.selectedIndex = 0;
        this.currentValue.size = '';
      }
      
      this.selectSize.disabled = this.selectSize.options.length > 1 ? false : true;
    }
    
    this.setFormData();
    this.updateButtonState();
  }
  
  setServiceSizeFormData() {
    if (this.selectSize) {
      this.currentValue.size = this.selectSize.value;
    }
    this.setFormData();
    this.updateButtonState();
  }
  
  toggleServiceAccordion(event) {
    event.preventDefault();
    const details = this.toggleService.closest('details');
    const hasValue = Array.from(this.querySelectorAll('select')).some((select) => select.value && select.value !== '');
    if (details.hasAttribute('open')) {
      if (!hasValue) {
        details.removeAttribute('open');
        this.toggleService.setAttribute('aria-expanded', 'false');
      }
    } else {
      details.setAttribute('open', '');
      this.toggleService.setAttribute('aria-expanded', 'true');
    }
  }
  
  setFormData() {
    // fix 4 - never call this function unless state is complete
    if (!this.currentValue.type && this.selectType?.value) return;
    // end fix 4

    this.inputType.value = this.currentValue.type || '';
    this.inputPrice.value = this.currentValue.price || '';
    this.inputSize.value = this.currentValue.size || '';
  }
  
  clearFormData() {
    this.currentValue = {
      type: '',
      size: '',
      price: '',
    };
    
    this.inputType.value = this.currentValue.type;
    this.inputPrice.value = this.currentValue.price;
    this.inputSize.value = this.currentValue.size;
  }
  
  updateButtonState() {
    const hasHemmingType = this.selectType && this.selectType.value !== '';
    const hasHemmingSize = this.selectSize && this.selectSize.value !== '';
    
    if ((hasHemmingType && !hasHemmingSize) ) {
      this.disableAddToCartButton();
    } else if (!this.buyButtonGroup.classList.contains('variant-available')) {
      this.disableAddToCartButton();
    } else {
      this.enableAddToCartButton();
    }
  }
  
  disableAddToCartButton() {
    this.addToCartButton.classList.add('disabled');
    this.addToCartButton.disabled = true;
    this.addToCartButton.addEventListener('click', this.preventButtonClick);
  }
  
  enableAddToCartButton() {
    const productInfo = document.querySelector('product-info');

    // FIX:
    // Hemming must not enable ATC while ProductInfo is
    // still synchronizing the selected variant.
    if (!productInfo?.isVariantReady) {
      return;
    }
    this.addToCartButton.classList.remove('disabled');
    this.addToCartButton.disabled = false;
    this.addToCartButton.removeEventListener('click', this.preventButtonClick);
  }
  
  preventButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();
  }
}

customElements.define('hemming-service-accordion', HemmingServiceAccordion);